import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_AD_CLIENTID,
        authority: process.env.REACT_APP_AZURE_AD_AUTHORITY,
        redirectUri: "/",
        postLogoutRedirectUri: "/",

    },
    system: {
        allowPlatformBroker: false, // Disables WAM Broker
    },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: []
};

export const apiRequest: PopupRequest = {
    scopes: [`api://${process.env.REACT_APP_AZURE_AD_API_CLIENTID}/access_as_user`]
};

// Separate request for BuddyNotes personnel scope — only used on-demand, NOT at app load
export const personnelRequest: PopupRequest = {
    scopes: [`api://${process.env.REACT_APP_PERSONNEL_SCOPE_AD_CLIENTID}/user_impersonation`],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: `${process.env.REACT_APP_API_URL}/profile`,
    graphProfileImageEndpoint: `${process.env.REACT_APP_API_URL}/profile/image`,
    tilesEndpoint: `${process.env.REACT_APP_API_URL}/tiles`,
    keySitesEndpoint: `${process.env.REACT_APP_API_URL}/tiles/key-sites`,
    navUrlsEndpoint: `${process.env.REACT_APP_API_URL}/navigation`,
    reportStatusEndpoint: `${process.env.REACT_APP_API_URL}/report/status`,
};